import { motion } from 'framer-motion';
import { Diamond, Play, Star } from 'lucide-react';

const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  visible: (i) => ({ opacity: 1, y: 0, transition: { delay: i * 0.08, duration: 0.5, ease: [0.25, 0.46, 0.45, 0.94] } }),
};

const TESTIMONIALS = [
  { name: 'Arjun M.', role: 'Jewelry Designer, Mumbai', text: 'Saved me 6 months of modeling work. The bridal ring collection alone is worth 10x the price.', hasVideo: true, stars: 5 },
  { name: 'Priya S.', role: '3D Print Studio Owner', text: 'My clients think I custom-model everything. The STL quality is insane — zero cleanup needed before print.', hasVideo: false, stars: 5 },
  { name: 'Rohit K.', role: 'CAD Freelancer, Jaipur', text: 'I was skeptical about 900GB but every single file opened clean in Rhino and ZBrush. Absolute goldmine.', hasVideo: true, stars: 5 },
  { name: 'Deepa T.', role: 'Etsy Seller', text: 'Went from 12 products to 200+ listings in one weekend. Already made back 50x what I paid.', hasVideo: false, stars: 5 },
  { name: 'Vikram N.', role: 'Production House, Surat', text: 'The export templates saved us weeks of setup. Everything is production-ready, no joke.', hasVideo: true, stars: 5 },
  { name: 'Ananya R.', role: 'Independent Designer', text: "Best purchase I made this year. The necklace and earring folders are chef's kiss.", hasVideo: false, stars: 5 },
];

function ChatBubble({ item, index }) {
  return (
    <motion.div custom={index + 3} initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeUp}
      className="card-elevated group p-5" data-testid={`testimonial-${index}`}>
      <div className="flex items-center gap-0.5 mb-3">
        {Array.from({ length: item.stars }).map((_, i) => (
          <Star key={i} className="w-3 h-3 fill-[#FDC3A1] text-[#FDC3A1]" />
        ))}
      </div>
      <p className="font-body text-sm text-[#444] leading-relaxed mb-4">"{item.text}"</p>
      <div className="flex items-center justify-between">
        <div>
          <span className="font-body text-sm text-[#111] font-semibold block">{item.name}</span>
          <span className="font-body text-[11px] text-[#999]">{item.role}</span>
        </div>
        {item.hasVideo && (
          <button data-testid={`testimonial-play-${index}`}
            className="flex items-center gap-1.5 px-3 py-1.5 text-[10px] uppercase tracking-wider font-bold font-body text-[#c88a5e] rounded-full transition-all hover:bg-[#FDC3A1]/10"
            style={{ border: '1px solid rgba(253,195,161,0.4)' }}
            onClick={() => alert('Video review placeholder — connect your video hosting here.')}>
            <Play className="w-3 h-3 fill-[#c88a5e]" />
            Watch
          </button>
        )}
      </div>
    </motion.div>
  );
}

export default function Testimonials() {
  return (
    <section data-testid="testimonials-section" className="relative py-20 sm:py-28" style={{ background: '#FFF7CD' }}>
      <div className="relative z-10 w-full max-w-6xl mx-auto px-6 sm:px-8">
        <motion.span custom={0} initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeUp}
          className="uppercase text-xs tracking-[0.25em] font-bold text-[#c88a5e] mb-4 block font-body" data-testid="testimonials-overline">
          <Diamond className="inline-block w-3 h-3 mr-2 -mt-0.5" /> Social Proof
        </motion.span>
        <motion.h2 custom={1} initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeUp}
          className="font-heading font-bold text-[#111] tracking-tight mb-4" style={{ fontSize: 'clamp(1.75rem, 4vw, 2.5rem)' }}
          data-testid="testimonials-headline">
          Designers Who Leveled Up
        </motion.h2>
        <motion.p custom={2} initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeUp}
          className="text-[#777] text-base md:text-lg font-body max-w-xl mb-12" data-testid="testimonials-description">
          Real feedback from creators who downloaded the vault.
        </motion.p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="testimonials-grid">
          {TESTIMONIALS.map((item, i) => <ChatBubble key={item.name} item={item} index={i} />)}
        </div>
      </div>
    </section>
  );
}
